import { Icon, IconNames } from '@shared/components/icons';
import { html } from '@shared/utils/rendering/html';
import { Features } from '../../constants/utility/features.constants';

const LoginConfig = {
    title: 'Enterprise Risk Management',
    brand: {
        icon: html`<${Icon} name=${IconNames.ShieldLock} />`,
        title: 'Sign in',
    },
    // The local login matches the account's username exactly (not its email address).
    username: { label: 'Username' },
    password: { label: 'Password' },
    internalLogin: {
        isVisible: true, // Hide on Prod somehow
        callback: null,
        label: 'Sign in',
    },
    externalLogin: {
        isVisible: true,
        callback: null,
        label: 'Standard Bank Login',
    },
    passwordReset: {
        isVisible: false,
        callback: () => {},
        label: 'Reset Password',
    },
    legal: '',
};

export const GenerateLoginConfig = (overrides, featureCheck) => {
    return {
        ...LoginConfig,
        internalLogin: {
            ...LoginConfig.internalLogin,
            callback: overrides?.internalLogin?.callback ?? LoginConfig.internalLogin.callback,
            isVisible:
                featureCheck(Features.internalLogin.key, Features.internalLogin.fallback) ??
                LoginConfig.internalLogin.isVisible,
        },
        externalLogin: {
            ...LoginConfig.externalLogin,
            callback: overrides?.externalLogin?.callback ?? LoginConfig.externalLogin.callback,
            isVisible:
                featureCheck(Features.externalLogin.key, Features.externalLogin.fallback) ??
                LoginConfig.externalLogin.isVisible,
        },
        passwordReset: {
            ...LoginConfig.passwordReset,
            callback: overrides?.passwordReset?.callback ?? LoginConfig.passwordReset.callback,
            isVisible:
                featureCheck(Features.passwordReset.key, Features.passwordReset.fallback) ??
                LoginConfig.passwordReset.isVisible,
        },
    };
};
